var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconImages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 1.66536V9.66536H4.33301V1.66536H12.333ZM12.333 0.332031H4.33301C3.59967 0.332031 2.99967 0.932031 2.99967 1.66536V9.66536C2.99967 10.3987 3.59967 10.9987 4.33301 10.9987H12.333C13.0663 10.9987 13.6663 10.3987 13.6663 9.66536V1.66536C13.6663 0.932031 13.0663 0.332031 12.333 0.332031ZM6.66634 6.7787L7.79301 8.28536L9.44634 6.2187L11.6663 8.9987H4.99967L6.66634 6.7787ZM0.333008 2.9987V12.332C0.333008 13.0654 0.933008 13.6654 1.66634 13.6654H10.9997V12.332H1.66634V2.9987H0.333008Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImages);
export default __webpack_public_path__ + "static/media/icon-images.8803908be18a8bcce3f09bc511d0f3c1.svg";
export { ForwardRef as ReactComponent };